import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    setSubmitting(true);
    try {
      await register(name, email, password);
      toast.success("Account created!");
      navigate("/");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Registration failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="register-page">
      <h1 className="font-display text-4xl text-deepbrown font-bold">Join Sutrakosh</h1>
      <p className="text-deepbrown/60 mt-2">Create an account to start shopping handmade goodies.</p>

      <form onSubmit={onSubmit} className="mt-8 space-y-4 bg-white rounded-2xl p-6 border border-deepbrown/10">
        <div>
          <Label>Full name</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name" />
        </div>
        <div>
          <Label>Email</Label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email" />
        </div>
        <div>
          <Label>Password</Label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="register-password" />
        </div>
        <button type="submit" disabled={submitting} className="w-full py-3 rounded-full bg-rani text-white font-bold hover:scale-[1.01] transition-transform disabled:opacity-50" data-testid="register-submit">
          {submitting ? "Creating…" : "Create Account"}
        </button>
        <p className="text-sm text-center text-deepbrown/60">
          Already have an account? <Link to="/login" className="text-rani font-semibold" data-testid="login-link">Sign in</Link>
        </p>
      </form>
    </div>
  );
}
